import script from "./Page__Sales.vue?vue&type=script&setup=true&lang=js"
export * from "./Page__Sales.vue?vue&type=script&setup=true&lang=js"

import "./Page__Sales.vue?vue&type=style&index=0&id=6072f535&lang=scss"

const __exports__ = script;

export default __exports__